/* eslint-disable import/prefer-default-export */
import { User, UserType } from '@centecomm/portal-service';

export const userIsTenant = (user: User): boolean =>
    !!user && user.hasOwnProperty('userType') && user.userType === UserType.Tenant;
